<template>
  <div class="app-container">
    <router-view />
  </div>
</template>

<script>
  import { setCampaignDefaults } from '../helpers'
  import { loadLocaleMessages } from '../lang/index'
  import _ from 'lodash'
  import screens from '../utils/pageSchema'
  export default {
    data() {
      return {
        wftkn: '',
        api: '/index.php?controller=social-login',
        i18nMessegesClone: null,
      }
    },
    computed: {
      baseData() {
        return this.$store.state.baseData
      },
      isPaidCampaign() {
        return !!this.baseData.paymentPlans
      },
      paidSessionOver() {
        return this.isRejeted && this.isPaidCampaign
      },
      isRejeted() {
        return this.$store.state.isRejeted
      },
      consentDone() {
        return !!this.$route.query.consent
      },
      showConsentForm() {
        return this.$store.state.baseData.flags.isConsent
      },
    },
    mounted() {
      console.log('[index.vue] mounted')

      // DEV MODE: Load real campaign data by campaign_id
      const devCampaignId = this.getValue('dev_campaign_id')

      if (devCampaignId && window.location.hostname === 'localhost') {
        console.log('🔍 DEV MODE: Loading campaign ID:', devCampaignId)

        axios
          .get('/index.php', {
            params: {
              controller: 'landingpage',
              action: 'get-campaign-payload',
              campaign_id: devCampaignId,
            },
          })
          .then((response) => {
            console.log('✅ Campaign data loaded from portal!', response.data)
            this.$store.commit('setWftkn', this.wftkn)
            this.setup(response.data)
          })
          .catch((error) => {
            console.error('❌ Failed to load campaign from portal:', error)
            console.log('ℹ️  Falling back to mock data...')
            const campaignInfo = JSON.parse(atob(base64data))
            this.$store.commit('setWftkn', this.wftkn)
            this.setup(campaignInfo)
          })
        return
      }

      // Normal flow: use base64data
      // this.wftkn = this.getValue('wftkn');
      const campaignInfo = JSON.parse(atob(base64data))
      // If we don't have a wftkn, and we aren't running a local build, then run in preview mode
      if (window.location.host === 'localhost:9000' || !campaignInfo.livePreview) {
        this.$store.commit('setWftkn', this.wftkn)
        this.setup(campaignInfo)
      } else {
        this.wftkn = '5f5a01d288036'
        this.$store.commit('setWftkn', this.wftkn)
        window.addEventListener('message', this.onCampaignChange, false)
      }
    },
    beforeDestroy() {
      window.removeEventListener('message', this.onCampaignChange, false)
    },
    methods: {
      onCampaignChange(e) {
        const eventId = e.data.event_id
        const dataPresent = !!e.data.data
        const activeTab = e.data.data?.development?.activeTab
        const currentPath = this.$router.currentRoute.path

        if (['campaign', 'thankyou', 'interstitial', 'prelogin'].includes(eventId)) {
          this.handlePostMessage(e)
        }

        if (dataPresent && activeTab === 'ads') {
          const isAdvertising = e.data.data.flags?.isAdvertising
          const hasPreLoginAd = isAdvertising && e.data.data.advertisement?.preLogin?.integrationId

          if (eventId === 'prelogin') {
            if (hasPreLoginAd) {
              this.handlePreLoginEvent(e)
            } else {
              this.setup(e.data.data)
              screens.advance()
            }
            return
          }

          if (eventId === 'interstitial') {
            this.handleInterstitialEvent(e)
            return
          }

          if (eventId === 'thankyou') {
            if (
              currentPath === '/pre-login-ad' ||
              currentPath === '/social-logins' ||
              currentPath === '/'
            ) {
              if (hasPreLoginAd) {
                this.handlePreLoginEvent(e)
              } else {
                this.setup(e.data.data)
                if (currentPath !== '/social-logins' && currentPath !== '/') {
                  screens.advance()
                }
              }
              return
            } else {
              this.handleThankYouEvent(e)
              return
            }
          }

          if (currentPath === '/pre-login-ad') {
            if (hasPreLoginAd) {
              this.handlePreLoginEvent(e)
            } else {
              this.setup(e.data.data)
              screens.advance()
            }
          } else if (currentPath === '/interstitial') {
            this.handleInterstitialEvent(e)
          } else if (currentPath === '/thankyou') {
            this.handleThankYouEvent(e)
          } else if (currentPath === '/social-logins' || currentPath === '/') {
            if (hasPreLoginAd) {
              this.handlePreLoginEvent(e)
            } else {
              this.setup(e.data.data)
            }
          }
          return
        }

        if (e.data.event_id === 'campaign' && dataPresent) {
          if (this.$i18n.locale !== e.data.data.langCode) {
            this.$i18n.locale = e.data.data.langCode
          }

          if (e.data.openCustomField) {
            this.$eventHub.$emit('showCustom', e.data.openCustomField)
          } else {
            this.$eventHub.$emit('showCustom', e.data.openCustomField)
          }
          this.handleCamapignEvent(e)
        } else if (e.data.event_id === 'thankyou' && dataPresent) {
          this.handleThankYouEvent(e)
        } else if (e.data.event_id === 'interstitial' && dataPresent) {
          this.handleInterstitialEvent(e)
        } else if (e.data.event_id === 'prelogin' && dataPresent) {
          this.handlePreLoginEvent(e)
        }
      },
      handleCamapignEvent(e) {
        e.data.data.backButton = true
        const {
          currentRoute: { path: curPath },
        } = this.$router
        if (
          e.data.data.development?.activeTab === 'covid19' &&
          e.data.data.flags?.isCovid === true
        ) {
          const baseData = this.baseData
          baseData.flags.isCovid = true
          this.$store.commit('setBaseData', baseData)
          if (curPath !== '/covid') {
            screens.advance()
          }
        } else {
          if (!!e.data.data.paymentPlans && e.data.data.paymentPlans.plans.length > 0) {
            screens.advance()
          } else if (!!e.data.data.socialMediaOrder && curPath !== '/social-logins') {
            screens.advance()
          }
        }
        this.setup(e.data.data)
      },
      handleThankYouEvent(e) {
        if (window.location.hash.substr(2) !== 'thankyou') {
          screens.advance()
        }
        this.setup(e.data.data)
      },
      handleInterstitialEvent(e) {
        // this is being called twice for some reason, and printing an error in console. this will prevent the error for now
        if (this.$router.currentRoute.path !== '/interstitial') {
          screens.advance()
          this.setup(e.data.data)
        }
      },
      handlePreLoginEvent(e) {
        const isAdvertising = e.data.data.flags?.isAdvertising
        const hasPreLoginAd = isAdvertising && e.data.data.advertisement?.preLogin?.integrationId

        if (hasPreLoginAd) {
          if (this.$router.currentRoute.path !== '/pre-login-ad') {
            screens.advance()
          }
          this.setup(e.data.data)
        } else {
          this.setup(e.data.data)
          screens.advance()
        }
      },
      handlePostMessage(e) {
        const lastPostMessage = e.data && JSON.stringify(e.data)
        this.$store.commit('setLastPostMessage', lastPostMessage)
        if (e.data.domain) {
          this.api = e.data.domain + '?preview=1'
        }
      },
      setRCI() {
        const queryString = window.location.search
        const urlParams = new URLSearchParams(queryString)

        const SUCID = urlParams.has('SUCID') ? urlParams.get('SUCID') : null

        if (SUCID) {
          localStorage.setItem('SUCID', SUCID)
        }
      },
      setLanguage() {
        const canBeNullThroughCustomLanguages = [
          'title_text',
          'sub_title_text',
          'footer_text',
          'support',
        ]
        if (
          this.baseData.flags.showMultilingual === 'true' ||
          this.baseData.flags.showMultilingual === true
        ) {
          for (const language in this.baseData.i18n) {
            const messages = { ...this.i18nMessegesClone[language] }
            for (const key in this.baseData.i18n[language]) {
              if (!_.isEmpty(this.baseData.i18n[language][key])) {
                messages[key] = this.baseData.i18n[language][key]
              }
              if (
                canBeNullThroughCustomLanguages.includes(key) &&
                _.isString(this.baseData.i18n[language][key])
              ) {
                messages[key] = this.baseData.i18n[language][key]
              }
            }
            this.$i18n.setLocaleMessage(language, messages)
          }
        } else {
          const language = this.baseData.language.defaultLanguage.langCode
          const messages = { ...this.i18nMessegesClone[language] }
          for (const key in this.baseData.i18n[language]) {
            if (!_.isEmpty(this.baseData.i18n[language][key])) {
              messages[key] = this.baseData.i18n[language][key]
            }
            if (canBeNullThroughCustomLanguages.includes(key)) {
              messages[key] = _.toString(this.baseData.i18n[language][key])
            }
          }
          this.$i18n.setLocaleMessage(language, messages)
        }

        const plume = this.getValue('is_plume') || this.getValue('plume_post')

        const localStorageLanguage = localStorage.getItem('selectedLanguage')

        let isError = false
        try {
          JSON.parse(localStorageLanguage)
        } catch (e) {
          isError = true
          localStorage.removeItem('selectedLanguage')
        }

        const selectedLanguage = isError === false ? JSON.parse(localStorageLanguage) : {}

        const pathName = window.location.pathname
        const parts = pathName.split('/')
        const pageName = parts.filter((part) => part.includes('.html'))[0]

        if (
          this.baseData.flags.showMultilingual === 'true' ||
          this.baseData.flags.showMultilingual === true ||
          plume
        ) {
          if (pageName && selectedLanguage && selectedLanguage[pageName]) {
            this.$i18n.locale = selectedLanguage[pageName]
            return
          }

          const queryString = window.location.search
          const urlParams = new URLSearchParams(queryString)

          const lang = urlParams.has('availableLanguages')
            ? urlParams.get('availableLanguages').split(',')
            : []

          const result = lang.find((langCode) => {
            return this.$i18n.messages[langCode] !== undefined
          })

          if (result) {
            this.$i18n.locale = result
          } else {
            if (navigator && navigator.languages && window.location.hostname !== 'localhost') {
              const navigatorResult = navigator.languages.find((langCode) => {
                return this.$i18n.messages[langCode] !== undefined
              })

              if (navigatorResult) {
                this.$i18n.locale = navigatorResult
              } else {
                this.$i18n.locale = this.baseData.language.defaultLanguage.langCode || 'en'
              }
            } else {
              this.$i18n.locale = this.baseData.language.defaultLanguage.langCode || 'en'
            }
          }

          const selectedStoredLanguage = Object.assign({}, selectedLanguage || {})
          if (pageName) {
            selectedStoredLanguage[pageName] = this.$i18n.locale
          }
          localStorage.setItem('selectedLanguage', JSON.stringify(selectedStoredLanguage))
        } else {
          this.$i18n.locale = this.baseData.language.defaultLanguage.langCode || 'en'
          localStorage.setItem('selectedLanguage', JSON.stringify(this.$i18n.locale))
        }
      },
      setHeaderFooter() {
        if (this.baseData.flags.isAdvertising === 'true') {
          const ckeditor = document.createElement('script')
          ckeditor.setAttribute('src', 'https://cdn.embedly.com/widgets/platform.js')
          ckeditor.setAttribute('async', true)
          ckeditor.setAttribute('charset', 'UTF-8')
          document.head.appendChild(ckeditor)
          ;(function (w, d) {
            const id = 'embedly-platform'
            const n = 'script'
            if (!d.getElementById(id)) {
              w.embedly =
                w.embedly ||
                function () {
                  ;(w.embedly.q = w.embedly.q || []).push(arguments)
                }
              const e = d.createElement(n)
              e.id = id
              e.async = 1
              e.src = 'https://cdn.embedly.com/widgets/platform.js'
              const s = d.getElementsByTagName(n)[0]
              s.parentNode.insertBefore(e, s)
            }
          })(window, document)
        }
      },
      addLayerStyle() {
        if (this.baseData.flags.backgroundLayer) {
          const styleElem = document.head.appendChild(document.createElement('style'))
          styleElem.innerHTML =
            '.background-image:before {background: ' + this.baseData.colors.layerColor + ';}'
        }
      },
      addCustomCSS() {
        if (
          !this.baseData ||
          !this.baseData.advancedOptions ||
          !this.baseData.advancedOptions.scripts
        ) {
          return
        }

        const customCSS = this.baseData.advancedOptions.scripts.customCSS
        const headCSS = this.baseData.advancedOptions.scripts.head

        let cssToInject = null

        if (customCSS && customCSS.trim() !== '') {
          cssToInject = customCSS
        } else if (headCSS && headCSS.trim() !== '') {
          cssToInject = headCSS
        } else {
          return
        }

        // Check if CSS selectors match any elements on the page
        if (!this.hasMatchingSelectors(cssToInject)) {
          return
        }

        const existingStyle = document.getElementById('custom-campaign-css')

        if (!existingStyle) {
          const styleElem = document.createElement('style')
          styleElem.id = 'custom-campaign-css'
          styleElem.innerHTML = cssToInject
          document.head.appendChild(styleElem)
        } else {
          existingStyle.innerHTML = cssToInject
        }

        this.$nextTick(() => {
          this.removeCSSFromBody()
        })
      },
      hasMatchingSelectors(cssText) {
        const rules = this.parseCSSRules(cssText)

        if (rules.length === 0) {
          return false
        }

        for (const rule of rules) {
          if (this.selectorMatchesElement(rule.selector)) {
            return true
          }
        }

        return false
      },
      parseCSSRules(cssText) {
        const rules = []
        // Remove comments
        const cleaned = cssText.replace(/\/\*[\s\S]*?\*\//g, '')

        // Split by closing brace to get individual rules
        const ruleBlocks = cleaned.split('}')

        for (const block of ruleBlocks) {
          const braceIndex = block.indexOf('{')
          if (braceIndex === -1) continue

          const selector = block.substring(0, braceIndex).trim()
          const properties = block.substring(braceIndex + 1).trim()

          if (selector && properties) {
            const selectors = selector
              .split(',')
              .map((s) => s.trim())
              .filter((s) => s)
            const baseSelector = selectors[0].replace(/::?[a-zA-Z-]+/g, '').trim()
            rules.push({
              selector: baseSelector,
              originalSelector: selectors[0],
              allSelectors: selectors,
              properties,
            })
          }
        }

        return rules
      },
      selectorMatchesElement(selector) {
        if (!selector || !document.body) {
          return false
        }

        try {
          if (selector.startsWith('#')) {
            const id = selector.substring(1).split(/[\s:.[]/)[0]
            if (document.getElementById(id)) {
              return true
            }
          }

          if (selector.startsWith('.')) {
            const className = selector.substring(1).split(/[\s:.[]/)[0]
            if (document.getElementsByClassName(className).length > 0) {
              return true
            }
          }

          if (/^[a-zA-Z][a-zA-Z0-9]*$/.test(selector.split(/[\s:.[]/)[0])) {
            const tagName = selector.split(/[\s:.[]/)[0]
            if (document.getElementsByTagName(tagName).length > 0) {
              return true
            }
          }

          const testSelector = selector.substring(0, 100)
          if (document.querySelector(testSelector)) {
            return true
          }
        } catch (e) {
          return false
        }

        return false
      },
      removeCSSFromBody() {
        const customScriptDiv = document.getElementById('custom-script')
        if (customScriptDiv) {
          customScriptDiv.style.display = 'none'
          customScriptDiv.innerHTML = ''
        }

        const body = document.body
        if (!body) return

        const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, null, false)

        const textNodesToRemove = []
        let node
        while ((node = walker.nextNode())) {
          const text = node.textContent || ''
          const isCSS =
            (text.includes('/*') && text.includes('*/')) ||
            (text.includes('{') && text.includes('}')) ||
            text.match(/[.#][a-zA-Z0-9_-]+\s*\{/) ||
            text.match(/^[a-zA-Z][a-zA-Z0-9_-]*\s*\{/) ||
            (text.includes(':') && (text.includes(';') || text.includes('!important')))

          if (isCSS) {
            let parent = node.parentNode
            let isInsideStyleTag = false
            while (parent && parent !== document.body) {
              if (parent.tagName === 'STYLE' || parent.id === 'custom-campaign-css') {
                isInsideStyleTag = true
                break
              }
              parent = parent.parentNode
            }

            if (!isInsideStyleTag) {
              textNodesToRemove.push(node)
            }
          }
        }

        textNodesToRemove.forEach((textNode) => {
          if (textNode.parentNode) {
            textNode.parentNode.removeChild(textNode)
          }
        })
      },
      getEmailFields(baseData) {
        if (
          !baseData.loginOptions ||
          !baseData.loginOptions.options ||
          !Array.isArray(baseData.loginOptions.options)
        ) {
          return
        }

        const emailFields = baseData.loginOptions.options.find((item) => {
          return item.name === 'Email'
        })
        if (emailFields) {
          const fields = emailFields.fields
          this.$store.commit('setFields', fields)
        }
      },
      setTextColor() {
        if (this.baseData.colors.textColor) {
          const textColor = this.baseData.colors.textColor
          this.$store.commit('setTextColor', textColor)
        }
      },
      addBackgroundColor() {
        if (this.baseData.colors.background === 'background-color: #ffffff') {
          this.baseData.colors.background = 'background-color: #f2f3f9'
        }
        if (
          this.baseData.images.background &&
          this.baseData.images.background.substr(0, 'background'.length) === 'background'
        ) {
          this.baseData.images.background = this.baseData.images.background.substr(
            this.baseData.colors.background.indexOf(':') + 1,
          )
        }
      },
      checkUserBlocked() {
        const reject = this.getValue('rej')

        if (reject) {
          this.$store.commit('setIsRejeted', true)
          this.$store.commit('setPreError', true)
          this.$store.commit('setPreErrorPayload', JSON.parse(decodeURIComponent(atob(reject))))
        }
      },
      checkIsPlumeCaptivePortal() {
        let isPlume = !!localStorage.getItem('isPlume')

        if (!isPlume) {
          isPlume = !!this.getValue('is_plume')
        }

        if (isPlume) {
          localStorage.setItem('isPlume', true)
        }
      },
      checkWelcomeBack() {
        const wb = this.getValue('wb')
        if (wb) {
          this.$store.commit('setWelcomeBack', true)
          const welcomeBackPayload = JSON.parse(atob(decodeURIComponent(wb)))
          this.$store.commit('setWelcomeBackPayload', welcomeBackPayload)
          if (
            welcomeBackPayload.first_name === 'No Name' ||
            welcomeBackPayload.first_name === '' ||
            welcomeBackPayload.first_name === 'Free'
          ) {
            welcomeBackPayload.first_name = ''
            this.$store.commit('setWelcomeBackPayload', welcomeBackPayload)
          }
        }
      },
      checkPlumeLogin() {
        const plume = this.getValue('plume_post')

        if (plume) {
          const plume_data = JSON.parse(decodeURIComponent(atob(plume)))
          this.$store.commit('setConnecting', true)
          this.$store.dispatch('fetchPlumeLogin', plume_data)
        }
      },
      checkForPlans() {
        if (this.baseData.paymentPlans) {
          this.$store.commit('setPaymentPlans', this.baseData.paymentPlans.plans)
        }
      },
      checkFreeOver() {
        const paid = this.getValue('paidonly')

        const freeOver = !!paid
        this.$store.commit('setFreeOver', freeOver)
      },
      checkBaseData() {
        if (
          this.baseData.images.header &&
          this.baseData.images.header !== '' &&
          !Array.isArray(this.baseData.images.header)
        ) {
          this.baseData.images.header = [this.baseData.images.header]
        }
        if (this.baseData.paymentPlans && !this.baseData.paymentPlans.fields) {
          this.baseData.paymentPlans.fields = []
        }
      },
      checkPostLogin() {
        const postLogin = this.getValue('postLogin')
        const postloginLower = this.getValue('postlogin') // Check lowercase too

        if (postLogin || postloginLower) {
          const requestId = this.getValue('request_id')
          const wftknForPostLogin = requestId || this.wftkn

          this.$store.commit('setConnecting', true)
          this.$store.dispatch('fetchPostLogin', wftknForPostLogin)
        }
      },
      async checkConsentDone() {
        if (this.consentDone) {
          screens.advance()
        }
      },
      getValue(name) {
        name = name.toLowerCase()
        const url = new URL(window.location.href)

        const result = url.searchParams.get(name)

        if (result) return result

        return ''
      },
      animateLogo() {
        const logo = document.getElementsByClassName('brand-logo')[0]

        if (logo) {
          const originalheight = logo.clientHeight
          let j = 1
          for (let i = originalheight; i > 40; i--) {
            setTimeout(() => {
              logo.style.height = i + 'px'
            }, 2 + j * 5)
            j++
          }
        }
      },

      checkArubaLogin() {
        const aruba = this.getValue('post')

        if (aruba) {
          this.$store.commit('setConnecting', true)
          const arubaPayload = JSON.parse(decodeURIComponent(atob(aruba)))
          this.doFormSubmit(arubaPayload, 0)
        }
      },

      doFormSubmit(arubaPayload, url) {
        // If we got an array of post URLs, try ajax with them
        if (Array.isArray(arubaPayload.post_url)) {
          return this.doAjaxFormSubmit(arubaPayload, url)
        }
        const form = document.createElement('form')
        form.setAttribute('method', 'post')
        form.setAttribute('action', arubaPayload.post_url)
        for (const key in arubaPayload) {
          if (Object.prototype.hasOwnProperty.call(arubaPayload, key)) {
            const hiddenField = document.createElement('input')
            hiddenField.setAttribute('type', 'hidden')
            hiddenField.setAttribute('name', key)
            hiddenField.setAttribute('value', arubaPayload[key])

            form.appendChild(hiddenField)
          }
        }
        document.body.appendChild(form)
        form.submit()
      },
      doAjaxFormSubmit(arubaPayload, url) {
        if (arubaPayload.post_url[url]) {
          const dataPost = Object.assign({}, arubaPayload)
          delete dataPost.post_url
          axios({
            method: 'post',
            url: arubaPayload.post_url[url],
            // It is necessary to axios identify and respect Content-Type 'application/x-www-form-urlencoded'
            data: qs.stringify(dataPost),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          })
            .then((res) => {
              if ((res.status === 200 || res.status === 301 || res.status === 302) && !!res.data) {
                if (arubaPayload.url) {
                  window.location.href = arubaPayload.url
                }
              }
            })
            .catch(() => {
              this.doAjaxFormSubmit(arubaPayload, url + 1)
            })
        } else {
          // fall back to old form submit method if we've tried all the other URLs
          arubaPayload.post_url = arubaPayload.post_url[0]
          this.doFormSubmit(arubaPayload)
        }
      },
      checkContract(baseData) {
        if (!baseData) return {}
        const versions = this.$store.getters.getContractVersions
        const currentVersion = baseData?.version ?? ''
        if (!versions.includes(currentVersion) || currentVersion === 'undefined') {
          if (this.$router.currentRoute.path !== '/contract-failed') {
            screens.advance()
          }
        }
      },
      checkDefaultCampaign() {
        const url = new URL(window.location.href)
        const defaultCampaign = url.searchParams.get('default_campaign')
        const defaultLocation = url.searchParams.get('default_location')
        sessionStorage.setItem('defaultCampaign', defaultCampaign === '1' ? 'true' : 'false')
        sessionStorage.setItem('defaultLocation', defaultLocation === '1' ? 'true' : 'false')
      },
      async setup(campaignInfo) {
        try {
          this.$store.commit('setOriginalData', JSON.parse(JSON.stringify(campaignInfo)))
        } catch (e) {
          console.error(e)
        }
        const baseData = setCampaignDefaults(campaignInfo)
        this.$store.commit('setBaseData', baseData)
        this.$store.commit('setApi', this.api)
        if (_.isNil(this.i18nMessegesClone)) {
          this.i18nMessegesClone = loadLocaleMessages()
        }
        this.checkIsPlumeCaptivePortal()

        this.setLanguage()
        this.setRCI()

        const logins = baseData.socialMediaOrder.split('&')
        this.$store.commit('setLogins', logins)
        this.$store.commit('setTitle1', campaignInfo.headerHtml)

        this.setHeaderFooter()

        this.getEmailFields(campaignInfo)

        this.setTextColor()

        this.addBackgroundColor()

        this.addLayerStyle()

        this.addCustomCSS()

        this.checkUserBlocked()

        this.checkWelcomeBack()

        this.checkPlumeLogin()

        this.checkArubaLogin()

        this.checkForPlans()

        this.checkFreeOver()

        this.checkBaseData()

        this.checkPostLogin()

        this.checkConsentDone()

        this.animateLogo()

        this.checkDefaultCampaign()

      },
    },
  }
</script>

<style>
  .app-container {
    height: -webkit-fill-available;
    display: flex;
    justify-content: center;
    font-family: 'Avenir Next';
    height: unset;
    min-height: 100vh;
    background: #ffffff;
  }
</style>
